import React from 'react';
import './Features.css';

import { features } from '../../../constants';
import { Feature } from '../../../components';



const Features = () => {

  return (
    <section className='features'>

      {/* Container for feature items */}
      <div className="box-container">

        {/* Map through each features and render each feature */}
        {features.map((feature) => (
          <Feature key={feature.id} feature={feature} />
        ))}

      </div>

    </section>
  );
}

export default Features;